import { ITradeIn } from '@/types/mkt.d';
import fetch, { NewAxiosRequestConfig } from '@/utils/axios';

type ParamsType = {
  [key: string]: any;
};

export const setLightningRemind = (params?: ParamsType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post('/ec/item/lightning_deals/remind', params, config);
};

export const getLightningShare = (params?: ParamsType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/mkt/activity/special_share', params, config);
};

// Coupon
export const getCouponList = (params?: ParamsType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/mkt/coupons/checkout', params, config);
};

/**
 * 使用优惠券接口
 * @param params
 */
export const applyCoupon = (params?: ParamsType): Promise<AResponse> => {
  return fetch.post('/ec/so/coupons/apply', params);
};
interface GetCollectionParams {
  products: number;
  key?: string;
  product_limit?: number;
}
/** 查询合集页面数据 */
export const getCollectionPageDetail = (collection_key: string, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/content/collection/${collection_key}`, { collection_key, page_type: 5 }, config);
};
/** 根据id集合获取商品详情 */
export const getProductDetailByIds = (data: ParamsType = {}, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post(
    '/ec/item/v5/product/query/ids',
    {
      source: data.source || 'collect',
      ...data
    },
    config
  );
};
/** 生鲜合集分享接口 */
export const getCollectShareInfo = (collection_key: string, config): Promise<AResponse> => {
  return fetch.get('/ec/content/collection/grocery/share', { collection_key }, config);
};
/**
 * 新用户绑定邮箱
 * @param params
 */
export const collectNewUserEmail = (params?: ParamsType): Promise<AResponse> => {
  return fetch.post('/ec/mkt/coupon/collect', params);
};

export const getActivity = (params?: ParamsType, config?: NewAxiosRequestConfig) => {
  return fetch.get('/ec/mkt/popup', params, config);
};
// redeem one click coupon
export const redeemCoupon = (
  params: Partial<{
    coupon_code: string;
    deal_id: string | number;
    type: string;
    vendor_id: string;
  }>,
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.post('/ec/mkt/coupons/redeem', params, config);
};

/**
 * 设置上架提醒
 * @param params product_id status
 * @param config ctx
 * @returns Promise
 */
export const setRemind = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post('/ec/item/lightning_deals/remind', params, config);
};

/**
 * 猜你喜欢
 */
export const getYouMayLike = (
  params?: { limit?: number; offset?: number },
  config?: NewAxiosRequestConfig
): Promise<AResponse> => {
  return fetch.get('/ec/item/v5/preference/home', params, config);
};

/**
 * 获取cart top info
 * @param config
 */
export const getCartTopInfo = (params?: ObjectType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/mkt/coupons/top_info', params || {}, config);
};

/**
 * 获取raffle
 * @param config
 */
export const getRaffleInfo = (eventKey: string, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get(`/ec/growth/lottery/info/${eventKey}`, {}, config);
};

// affiliate banner info
export const getAffiliateInfo = (params?: ParamsType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/mkt/affiliate/get_affiliate_info', params, config);
};

/**
 *  获取onboarding页面订单下载数量
 *  @param type
 */
export const getSiteData = (config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/mkt/onboarding/site_data_info', {}, config);
};

/**
 * 活动中心-获取存在弹窗的pagekey集合
 *  @param type
 */
export const getActivityConfig = (params?: ParamsType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/activity/popup/precheck', params, config);
};

/**
 * 活动中心-页面弹窗内容
 *  @param type
 */
export const getActivityContent = (params?: ParamsType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/activity/popup/page', params, config);
};

/**
 * 活动中心-活动查看成功
 *  @param type
 */
export const setActivitySuccess = (params?: ParamsType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.put('/ec/activity/popup/success', params, config);
};

/**
 * swith new store popup
 *  @param type
 */
export const getNewStorePopup = (params?: ParamsType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/activity/popupContent/contentInfo', params, config);
};

export const getSequentialCoupons = (params?: ParamsType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/mkt/coupon/twocoupons/info', params, config);
};

/*
 * mkt 接口移至mkt文件
 */
export const getDisaccountList = (
  params?: ObjectType,
  config?: NewAxiosRequestConfig
): Promise<AResponse<ITradeIn>> => {
  return fetch.get('/ec/mkt/activity/trade_in', params, config);
};

/*
 * 活动中心-points special活动
 */
export const getCopyInfo = (params?: ParamsType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/mkt/message/new_user_message', params, config);
};

/**
 *
 * @param req 获取是否返利联盟用户
 * @returns
 */
export const getRefererInfo = (params?: ParamsType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.post('/ec/mkt/affiliate/get_referral_user', params, config);
};

/*
 * Loyalty popup message
 */
export const getLoyaltyPopMessage = (params?: ParamsType, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/mkt/message/new_user_message', params, config);
};
